<template lang="html">
  <div class="page">
    <div class="page-content">
      <page-nav-bar currentServiceName="MoneyRoad" subNavTitle="Import CSV File" :ReturnButton="true" v-if="isSmartphone"></page-nav-bar>
      <div class="layoutTop"/>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <div class="panel21 panel-default">
                  <h4 class="content-block labelAccordionForm">
                      <f7-icon f7='list_bullet'></f7-icon>
                      Import Direct Payments <span v-if="importType === 'draft'">(In Progress)</span>
                  </h4>
              <form>
                <div class="form-group row">
                  <label class="col-5 col-sm-2" :class="colorBottomButton">
                    <div class="fileContainer">
                      Choose file
                      <input ref="fileInput" type="file" name="file2" id="file2" @change="onFileChange"></input>
                    </div>
                  </label>
                  <div class="col-7 col-sm-10">
                    <input class="form-control" name="filename" placeholder="Choose file" type="text" v-model="fileName" disabled></input>
                  </div>
                </div>
                <b-row v-if="importType === 'draft' && accountType === '1'">
                  <b-col>
                    <b-form-select class="form-control" id="sel1" readonly v-model="id_team" :options="teamOptions"></b-form-select>
                  </b-col>
                </b-row>
              </form>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2 offset-md-9" :class="colorBottomButton">
            <button round class="importAttachmentButton button-action firstButtonMarginTop" @click="importFile">
              <f7-icon f7='list_bullet'></f7-icon>
              <span>Import</span>
            </button>
          </div>
        </div>
      </div>

    <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
</template>

<script>

import pageNavBar from '@/components/common/pageNavBar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'importDP',
  props: ['importType'],
  components: {
    'page-nav-bar': pageNavBar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      fileName: '',
      fileData: '',
      mimeType: '',
      accountType: '',
      idTeam: '',
      teams: [],
      teamOptions: [],
      ibans: [],
      isSmartphone: false
    }
  },
  created () {
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    this.accountType = this.$engine.user.get().type
    this.setTeams()
    this.ibans = this.$engine.bankAccounts.get().map(account => { return account.iban })
  },
  methods: {
    importFile () {
      // Separation des infos (fileParts[0]) et data (fileParts[1]) du fichier
      let fileParts = this.fileData.split(',')

      // Check si fichier est vide
      if (fileParts.length < 2) {
        // error
        if (fileParts[0] === '') {
          this.$f7.alert('', 'No File Selected')
        } else {
          this.$f7.alert('', 'Empty File')
        }
        loadPage(this, {url: '/directPayments/sendbox/report/'})
        return
      }

      // Conversion base64 --> string
      let data = atob(fileParts[1])

      // Explosion du contenu ligne pas ligne, puis champs par champs (CSV)
      let lines = []
      data.split('\n').forEach(e => {
        lines.push(e.split(';'))
      })

      let report = []

      // Traitement ligne par ligne (création des DP)
      this.$f7.showPreloader('Sending Direct Payments')
      lines.forEach((line, index, list) => {
        if (line.length >= 19) { // Si la ligne suit le bon format d'entrée
          if (this.importType !== undefined && this.importType === 'payment') {
            report.push(this.createDP(line))
          } else if (this.importType !== undefined && this.importType === 'draft') {
            report.push(this.createDraft(line))
          }
        } else if (line.length <= 1) { // Si la ligne est vide
          list.splice(index, 1)
        }
      })
      this.$f7.hidePreloader()

      // Enregistrer le report en mémoire
      this.$engine.services.directPayments.setReport(report)

      // Redirection vers la page de report
      loadPage(this, {url: '/directPayments/sendbox/report/'})
    },
    createDP (infoTab) {
      // Création des params pour DP Create
      let dpinfo = {
        creditorIdentifier: infoTab[0],
        creditorName: infoTab[1],
        creditorBankAccount: infoTab[2],
        // infoTab[3]
        debtorIdentifier: this.$engine.user.get().identifier,
        debtorName: this.$engine.user.get().name,
        debtorBankAccount: infoTab[6],
        // infoTab[7]
        amount: infoTab[8],
        currency: infoTab[9],
        executionDate: infoTab[10],
        reason: infoTab[11],
        endToEndId: infoTab[12],
        creditorZoneCode: infoTab[13],
        debtorZoneCode: infoTab[14],
        attachmentName: infoTab[15],
        attachmentReference: infoTab[16],
        attachmentData: infoTab[17] + ';' + infoTab[18],
        done: 'NA'
      }

      // Check si IBAN correspond au compte connecté
      if (!this.ibans.includes(dpinfo.debtorBankAccount)) {
        dpinfo.done = 'wrong'
        return dpinfo
      }

      // Requête à l'engine pour création de la DP
      this.$engine.services.directPayments
      .create(dpinfo)
      .then(response => {
        // Succes de la création
        if (response.status === 200) {
          dpinfo.done = 'success'
        }
      })
      .catch(error => {
        // Echec de la création
        dpinfo.done = 'error'
        dpinfo.error = error
        // console.error(error)
      })

      return dpinfo
    },
    createDraft (infoTab) {
      // Creation des params pour Draft create
      let draftinfo = {
        idAccount: this.$engine.user.get().id,
        id_creator: this.$engine.user.userAccountId,
        id_team: this.id_team,
        CreditorIdentifier: infoTab[0],
        CreditorName: infoTab[1],
        CreditorBankAccount: infoTab[2],
        DebtorIdentifier: this.$engine.user.get().identifier,
        DebtorName: this.$engine.user.get().name,
        DebtorBankAccount: infoTab[6],
        Amount: infoTab[8],
        Currency: infoTab[9],
        RequestedExecutionDate: infoTab[10],
        RemittanceInformation: infoTab[11],
        DraftName: infoTab[11],
        creditorZoneCode: infoTab[13],
        debtorZoneCode: infoTab[14],
        AttachmentName: infoTab[15],
        AttachmentReference: infoTab[16],
        Attachment: infoTab[17] + ';' + infoTab[18],
        done: 'NA'
      }

      // Format draftinfo in info pour report
      // Idealement, il faudrait que la modé create draft prenne le même format de params que create DP pour les champs équivalent
      // ex : reason/RemittanceInformation ; creditorIdentifier/CreditorIdentifier
      let info = {}
      for (var key in draftinfo) {
        let newKey = ''
        switch (key) {
          case 'RemittanceInformation':
            newKey = 'reason'
            break
          case 'RequestedExecutionDate':
            newKey = 'executionDate'
            break
          default:
            newKey = key.charAt(0).toLowerCase() + key.slice(1)
            break
        }
        info[newKey] = draftinfo[key]
      }

      // Check si IBAN correspond au compte connecté
      if (!this.ibans.includes(info.debtorBankAccount)) {
        info.done = 'wrong'
        return info
      }

      // Création du draft
      this.$engine.dpDrafts.create({'drafts': [draftinfo]})
      .then(response => {
        if (response.status === 200) {
          info.done = 'success'
        }
      })
      .catch(error => {
        info.done = 'error'
        info.error = error
        // console.error(error)
      })

      // Return info pour compléter le report
      return info
    },
    onFileChange (e) {
      let that = this
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 1000000) {
        that.createImage(files[0])
        that.fileName = files[0].name
        that.mimeType = files[0].type
      } else {
        that.$f7.alert('This file has a size of ' + Math.round(files[0].size / 1000) + 'Kb. \n Maximum permited is 1MB', 'Maximum file size exceeded')
      }
    },
    createImage (file) {
      let reader = new FileReader()
      let that = this
      this.$f7.modal({
        title: 'Charging File',
        text: '<span class="preloader"></span>'
      })
      reader.onload = (e) => {
        that.fileData = e.target.result
        that.$f7.closeModal()
      }
      reader.readAsDataURL(file)
    },
    setTeams () {
      let that = this
      // Init teams
      that.teams = that.$engine.accounts.getPersonnalTeams()
      // Init teams default select
      if ((typeof that.teams) !== 'undefined' && that.teams.length > 0) {
        that.id_team = that.teams[0].id_team
        // Init teams select options
        for (var i = 0; i < that.teams.length; i++) {
          that.teamOptions[i] = {value: that.teams[i].id_team, text: that.teams[i].team_label}
        }
      }
    }
  }
}
</script>

<style scoped>
.fileContainer [type=file] {
    display: none;
    color: white;
}
.fileContainer {
  text-decoration: none;
  text-align: center;
  border-radius: 27px;
  line-height: 25px;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  padding: 0 10px;
  margin: 0;
  height: 27px;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  outline: 0;
  width: auto;
  float: right;
}
.attachmentImportButtonLength {
  width: 101px;
}
.progressbar {
  height: 8px;
}

.list-block {
    padding: 0px 0px 0px 0px;
    margin: auto;
    width: 90%
}

.button.button-round {
    border-radius: 27px;
    margin: auto;
}
.panel-heading {
    padding: 10px 15px;
    border-bottom: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    text-transform: uppercase;
}
. {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// ImportDP.vue?24e82db3